/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_verify_identity_go_home = /** @type {(inputs: {}) => string} */ () => {
	return `Ir al Inicio`
};

const en_verify_identity_go_home = /** @type {(inputs: {}) => string} */ () => {
	return `Go to Home`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const verify_identity_go_home = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.verify_identity_go_home(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("verify_identity_go_home", locale)
	if (locale === "es") return es_verify_identity_go_home(inputs)
	return en_verify_identity_go_home(inputs)
};
export { verify_identity_go_home as "verify_identity.go_home" }